(() => {
  const links = document.querySelectorAll('[data-blx-cart-link]');
  if (!links.length) return;
  const menu = document.querySelector('.blx-launch-menu');
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); }
  });
  document.addEventListener('click', event => {
    if (menu?.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
  const update = count => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    links.forEach(link => {
      link.querySelector('[data-blx-cart-count]').textContent = count;
      link.setAttribute('aria-label', link.dataset.countLabel.replace('{count}', count));
    });
  };
  let reading = false;
  const sync = async () => {
    if (reading || document.visibilityState === 'hidden') return;
    reading = true;
    try {
      const response = await fetch(links[0].dataset.cartJsonUrl, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(10000) });
      if (response.ok) update((await response.json()).item_count);
    } catch {} finally { reading = false; }
  };
  document.addEventListener('blx:cart-updated', event => update(event.detail.itemCount));
  window.addEventListener('pageshow', event => { if (event.persisted) sync(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') sync(); });
})();
